import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Notification from 'flarum/forum/components/Notification';
import { getContrastTextColor } from '../../common/utils/color';
export default class CustomNotification extends Notification {
  icon() {
    var _this$attrs$notificat;
    return (_this$attrs$notificat = this.attrs.notification) == null || (_this$attrs$notificat = _this$attrs$notificat.content()) == null ? void 0 : _this$attrs$notificat.icon;
  }
  href() {
    var _this$attrs$notificat2;
    return (_this$attrs$notificat2 = this.attrs.notification) == null || (_this$attrs$notificat2 = _this$attrs$notificat2.content()) == null ? void 0 : _this$attrs$notificat2.url;
  }
  excerpt() {
    var _this$attrs$notificat3;
    return (_this$attrs$notificat3 = this.attrs.notification) == null || (_this$attrs$notificat3 = _this$attrs$notificat3.content()) == null ? void 0 : _this$attrs$notificat3.excerpt;
  }
  content() {
    var _this$attrs$notificat4;
    const message = (_this$attrs$notificat4 = this.attrs.notification) == null || (_this$attrs$notificat4 = _this$attrs$notificat4.content()) == null ? void 0 : _this$attrs$notificat4.message;
    return m('div', message);
  }
  view(vnode) {
    var _this$attrs$notificat5;
    const view = super.view(vnode);
    const color = (_this$attrs$notificat5 = this.attrs.notification) == null || (_this$attrs$notificat5 = _this$attrs$notificat5.content()) == null ? void 0 : _this$attrs$notificat5.color;
    if (color && view && view.attrs) {
      const textColor = getContrastTextColor(color);
      view.attrs.style = _objectSpread(_objectSpread({}, view.attrs.style), {}, {
        backgroundColor: color
      }, textColor ? {
        '--notificationhub-text-color': textColor
      } : {});
    }
    return view;
  }
}
flarum.reg.add('huseyinfiliz-notificationhub', 'forum/components/customNotification', CustomNotification);